import { mdiBluetooth, mdiWhiteBalanceAuto } from "@mdi/js";
import { signInWithCustomToken } from "firebase/auth";
import reactDom from "react-dom";
import { StyleSheet, Dimensions } from "react-native";
import { color } from "react-native-reanimated";
import { variables } from "../config_variables/variables";
// import { lightgrey } from "../constants/styles";

const font_family = [
  "lucida grande",
  "tahoma",
  "verdana",
  "arial",
  "sans-serif",
];

/* color codes */
const color_codes = {
  lightgrey: "#d3d3d3",
  darkgrey: "#a9a9a9",
  lightsteelblue: "#b0c4de",
  sienna: "#a0522d",
  cornflowerblue: "#6495ed",
  linen: "#faf0e6",
  navy: "#000080",
  royalblue: "#4169e1",
  screen4_values: "rgb(138, 130, 130)"
};

const circle_radius = {
      // large: 50,
      large: 40,
      medium: 25,
      small: 10
}



const app_screen_width =
//   0.5 * Dimensions.get("window").width;
  0.98 * Dimensions.get("window").width;
//   0.18 * Dimensions.get("window").width;
//   0.2 * Dimensions.get("window").width;
//   0.25 * Dimensions.get("window").width;
  // 0.45 * Dimensions.get("window").width
  // 0.368 * Dimensions.get("window").width
// 0.398 * Dimensions.get("window").width
// 0.498 * Dimensions.get("window").width
// ? 0.6 * Dimensions.get("window").width
// ? 0.9 * Dimensions.get("window").width

/* dimensions*/
const device_width = Dimensions.get("window").width;
const device_height = Dimensions.get("window").height;
console.log("dimensions are W/H : " + device_width, device_height);

const style_templates = StyleSheet.create({
  home_screen_container: {
    // width: 10,
    // display: "flex",
    justifyContent: "center",
//     borderWidth:10,
//     borderColor:"black"
    // alignItems: "center",
  },

  header_text_container: {
      // borderWidth:10,
//     borderColor:"green",
    textAlign: "center",
    paddingTop: 30
  },

  home_screen_image: {
    flex: 1,
    flexDirection: "column",
    marginLeft: variables.isDesktop ? 400 : 0,
    width: variables.isDesktop
      ? 0.6 * Dimensions.get("window").width
      : Dimensions.get("window").width,
    height: Dimensions.get("window").height * .9,
  },

  home_screen_title: {
    flex: 1,
    // marginTop: 150,
    color: "#7b68ee",
    fontSize: 20,
  },

  home_screen_button_group_container: {
    display: "flex",
    flexDirection: "row",
    marginTop: Dimensions.get("window").height * 0.5,
    paddingLeft: variables.isDesktop ? 20 : 0,
    justifyContent: "center",
    alignItems: "center",
    // width: 300,
  },

  /*************  full screen window******************/
  app_container: {
    // backgroundColor: "#d3d3d3",
    // backgroundColor: "#add8e6",
    // display: "flex",
    // flexDirection: "column",
//     height: "80%",
    flex: 1,
//     borderColor: "red",
//     borderWidth: 10,
    // // borderRadius:10,
    justifyContent: "center",
    alignItems: "center",
    marginRight: variables.isDesktop ? 0 : 5,
  },

/*************  screen/phone boundary ******************/
  app_body_container: {
      // height: "80%",
      // flex:1,
      flexDirection:"column",
    borderColor: color_codes.lightgrey,
    borderWidth: 1,
//     marginTop:60,
//     marginBottom:100,
    borderRadius:80,
//     justifyContent: "center",
//     alignItems: "center",
    flex: 1,
  },


/*************  MAIN SCREEN:  OUTER CONTAINER  ******************/
  app_body_container_screen2: {
      // height: "80%",
      // flex:1,
      // flexDirection:"column",
      flexDirection:"row",
//     borderColor: color_codes.lightgrey,
//     borderColor: "black",
//     borderWidth: 10,
//     marginTop:60,
//     marginBottom:100,
//     borderRadius:80,
//     borderWidth:10,
//     borderColor: "orange",
      width: app_screen_width,

//     justifyContent: "center",
//     alignItems: "center",
    flex: 1,
  },


  /*************  MAIN SCREEN:  LEFT PANEL  ******************/

  panel_container: {
      // height: "80%",
      flex:1,
      // flexDirection:"column",
      flexDirection:"column",
//     borderColor: color_codes.lightgrey,
//     borderColor: "blackj8bjbinjnbbbbbnnnnj9n",
//     borderWidth: 10,
//     marginTop:60,
//     marginBottom:100,
//     borderRadius:80,
//     borderWidth:variables.showBordersFlag ? 10 : 0,
//     borderWidth:2 ,
//     borderColor: "lightgrey",
      // width: app_screen_width,

//     justifyContent: "center",
//     alignItems: "center",
  },

  panel_container_custom: {
      height: "150%",
      // flex:1,
      // flexDirection:"column",
      flexDirection:"column",
//     borderColor: color_codes.lightgrey,
//     borderColor: "black",
//     borderWidth: 10,
//     marginTop:60,
//     marginBottom:100,
//     borderRadius:80,
    borderWidth:variables.showBordersFlag ? 10 : 0,
    borderColor: "green",
      // width: app_screen_width,

//     justifyContent: "center",
//     alignItems: "center",
  },



/*************  SCREEN 1 + 2 : contains header & cards on screen 1 , just header on screen 2 ******************/
  app_sub_container_header: {
//     borderWidth: 12,
//     borderColor: "orange",
    flex: 1,
    flexDirection: "column",
//     marginTop: 20,
//     paddingTop:20,
//     borderRadius:80,
//     borderTopLeftRadius:80,
//     borderTopRightRadius:80,
//     borderRadius:80,
//     backgroundColor: "white",
    backgroundColor: "white",
    paddingBottom:0,
//     overflow:"scroll"
//     backgroundColor: color_codes.lightgrey,
    // backgroundColor:  "#deb887",
    // width: 600,
//     width: variables.isDesktop
//       ? app_screen_width
//       // : app_screen_width,
//       : Dimensions.get("window").width,
    // height: Dimensions.get("window").height * 0.2,
    borderWidth: variables.showBordersFlag ? 10 : 0,
    borderColor:"black"
  },

/************* SCREEN 1:  bottom container on screen 1 with summary values ******************/
screen1_summary_container: {
    flex:1,
//     marginTop:-500,
      //   borderWidth:10,
//     borderColor:"yellow",
    flexDirection:"row",

},

screen1_summary_container_box: {
      flex:1,
      paddingTop:20,
      paddingBottom:20,
      flexDirection:"row",
      // borderWidth:1,
      // borderColor:"red",
},

screen1_summary_container_sub_box_left: {
      flex:1,
      // borderLeftColor:"blue",
      // borderLeftWidth:5,
},

screen1_summary_container_sub_box_right: {
      flex:6,
      borderLeftColor:"orange",
      borderLeftWidth:5,
      paddingLeft:10,
},

screen1_summary_container_text: {
      fontSize:16,
      fontWeight: "bold",
},


/*************  screen 2 : Text around toggle switches ******************/ 
  screen2_toggle_switch_text : {
      // paddingHorizontal:20,
      paddingLeft:20,
      paddingRight:20,
      // color:"white",
      color:"rgb(220, 204, 204)",
      fontWeight:"bold"
  },

/*************  screen 2 : container for toggle switches ******************/ 
screen2_toggle_switch_container: {
      // marginLeft:10,
      // marginRight:10,
},

/*************  screen 2 : container for toggle switches ******************/ 
screen2_toggle_switch_text_container : {
justifyContent: "center",
textAlign: "center",
},

/*************   SCREEN 2 : row/cards container for screen 2 (Filters) & screen 3 (Lots List)******************/ 
  app_sub_container_header_row_container: {
    flex: 1,
    flexDirection: "row",
    marginRight: 15,
//     paddingLeft: 15,
//     marginTop:20,
    // borderBottomColor:color_codes.lightgrey,
    // borderBottomColor:color_codes.lightgrey,
    // borderBottomWidth:1,
    borderRadius: 5, // borderColor: 'green',
    justifyContent: "center",
    alignItems: "center",
    overflow:"hidden",
//     borderWidth: 5,
//     borderColor: "yellow",
  },


/*************  SCREEN 2 : text boxes containing metrics ******************/ 
  app_sub_container_header_row_container_box: {
    flex: 1,
    // backgroundColor: "yellow",
    // margin:5,
    backgroundColor: "white",
    //  flexWrap: 'wrap',
    //  flexShrink: 1,
    // width: 0,
    // flexGrow: 1,
    flexDirection: "column",
    // flexDirection: "row",
//     borderColor: "red",
//     borderWidth: 5,
    alignItems: "flex-start",
    justifyContent: "flex-start",
//     height: "80%",
//     height: 60,
    height: 86,
    // borderBottomColor:color_codes.lightgrey,
    // borderLeftColor:color_codes.lightgrey,
    // borderBottomWidth:1,
    // borderLeftWidth:5,
//     paddingTop: 15,
//     paddingBottom: 15,
    marginLeft: 15,
    marginTop:20,
//     marginTop: 25,
    borderRadius: 4,
    textAlign: "center",
    shadowColor: "#171717",
    shadowOffset: { width: -2, height: 4 },
    shadowOpacity: 0.2,
    shadowRadius: 6,
    elevatoin: 10,
  },


/*************  SCREEN 2 : text boxes containing selected filters ******************/ 
filter_text_container: {
    flex: 1,
//     borderWidth:1,
//     borderColor:color_codes.lightgrey,
    borderRadius:20,
    justifyContent:"center",
    textAlign: "center"

  },

/*************  SCREEN 2 : filter text styling ******************/ 
filter_text_label: {
    color: "white",
    fontSize: 10,
//     fontWeight: "bold",
//     paddingBottom: 5,
},

/*************  to be deprecated  ******************/ 
    screen1_container: {
    flex: 1,
    flexDirection: "column",
    marginRight: 15,
    // borderBottomColor:color_codes.lightgrey,
    // borderBottomColor:color_codes.lightgrey,
    // borderBottomWidth:1,
    borderRadius: 5, // borderColor: 'green',
    // justifyContent: "center",
//     alignItems: "center",
//     borderWidth: 10,
//     borderColor: "brown",
  },
  
/*************  wrapper for header text box ******************/
screen1_header : {
      textAlign:"left",
      paddingLeft:20,
      paddingRight:20,
      // marginBottom:20,
      bottomBorderWidth:20,
      // bottomBorderColor:"red",
      // marginTop:60,
      // marginBottom:20,
      fontFamily: "Open Sans",
      // backgroundColor: "lightgrey"
      backgroundColor: "rgb(61, 90, 92)",
      borderBottomWidth:10,
      // borderBottomColor: "yellow",
      // borderBottomColor: "rgb(146, 146, 108)",
      borderBottomColor: "rgb(211, 92, 34)",
      
},

/*************  header text  ******************/
screen1_header_text : {
      fontSize:17,
      fontWeight:"bold",
      // color:"rgb(132, 128, 128)",
      color: "lightgrey",
      marginBottom:30,
      marginTop:40,
      textAlign: "center",
},

login_page_header_text: {
  fontSize:30,
  fontWeight:500,
  color:"200",
  marginBottom:80,
  fontFamily: 'Arial',
  textDecorationLine: 'underline',
  textDecorationThickness: '6px',
  textUnderlineOffset: '1rem',
  borderColor:"green",
  borderWidth: variables.showBorders ? variables.borderWidthsForTest : 0,            
},

/*************  cards on screen 1 ******************/
screen1_loader_box: {  
      // flex:1,
      // paddingLeft: (app_screen_width/2) - 40,
      justifyContent:"center",
      textAlign: "cemter",
      borderWidth: variables.showBordersFlag ? 15 : 0,
    borderColor: "magenta",
},

screen1_container_box: {
    elevation: 7,
//     flex: 1,
    // height:20,
    flexDirection: "row",
    borderRadius: 5,
//     borderWidth:15,
//     borderColor: "magenta",
    paddingHorizontal: 15,
            paddingRight:20,
    marginBottom: 5,
    // marginTop: 3.5,
    marginLeft:10,
    marginRight:10,
//     borderTopWidth: 1,
    borderBottomWidth: 1,
//     borderTopColor: color_codes.lightgrey,
    borderBottomColor: "rgb(246, 233, 233)",
    // paddingHorizontal: 10,
//     height: variables.isDesktop
//       ? // ? 0.075 * Dimensions.get("window").height
//         0.09 * Dimensions.get("window").height
//       : 0.1 * Dimensions.get("window").height,
    // width: "90%",
    // width: "100%",
    // width:
    //   variables.isDesktop
    //     ? 0.275 * Dimensions.get("window").width
    //     : 0.99 * Dimensions.get("window").width,

//     width: variables.isDesktop
//       ? 0.96 * app_screen_width
//       : Dimensions.get("window").width,

    // backgroundColor: "white",
    backgroundColor: "rgb(230, 230, 230)",
    // backgroundColor: "#f8f8ff",
    alignItems: "center",
    justifyContent: "space-between",
    // marginLeft: 1,
    // marginRight: 1

//     shadowColor: "#171717",
//     shadowOffset: { width: -2, height: 4 },
//     shadowOpacity: 0.2,
//     shadowRadius: 3,      
  },


  screen1_container_box_icon: {
//     flex:1,
padding:5,
      //   borderColor: "red",
//     borderWidth: 5,
    justifyContent:"center",
    textAlign:"center"
  },
  
  screen1_container_box_count_and_text: {
      flex:4,
      flexDirection: "column",
      // borderColor: "red",
      // borderWidth: 5,    
      marginLeft: 20,
  },

  screen1_container_box_count: {
    flex:1,
},

screen1_container_box_text: {
    flex:1,
  },

/*************  footer on screen 1 ******************/
  screen1_footer : {
      flex:1,
      // borderRadius:80,
      backgroundColor:color_codes.lightgrey,
  zIndex: 1, // works on ios
  elevation: 1, // works on android
      // width: variables.isDesktop
      // ? app_screen_width
      // // : app_screen_width,
      // : Dimensions.get("window").width,
      // borderWidth:10,
      // borderColor: "green",

},

// /*************  bottom nav bar on screen 1  to give appearance of mobile phone ******************/
// bottom_nav_bar : {
//       flex:1,
//       borderRadius:180,
//       backgroundColor:color_codes.lightgrey,
//     marginBottom:0

// },




  app_sub_container_header_row_container_box_top_container: {
    flex: 1,
    // alignItems: "left",
    textAlign: "left",
    justifyContent: "flex-end",
    // borderWidth:1,
    // borderColor: "red",
    width: "80%",
    borderLeftColor: color_codes.lightgrey,
    borderLeftWidth: 3,
    // borderBottomColor:color_codes.lightgrey,
    // borderBottomWidth:1,
    paddingLeft: 10,
  },

  app_sub_container_header_row_container_box_middle_container: {
    flex: 0,
    // textAlign: "left",
    paddingLeft: 15,
    width: "65%",
    alignItems: "left",
    // marginTop:5,
    // marginBottom:5,
    borderBottomWidth: 1,
    borderBottomColor: color_codes.linen,
  },

  app_sub_container_header_row_container_box_bottom_container: {
    flex: 1,
    textAlign: "left",
    // alignItems: "center",
    // justifyContent: "flex-start",
    // borderWidth:1,
    // borderColor: "green",
    width: "80%",
    borderLeftColor: color_codes.lightgrey,
    // borderBottomColor:color_codes.lightgrey,
    borderLeftWidth: 3,
    paddingLeft: 10,
  },

/*************  SCREEN 1 : text description for counters ******************/

    screen1_desriptive_text: {
      fontFamily: variables.global_font_specs.family,
      color: "rgb(143, 127, 127)",
      //     color: "white",
      fontSize: 15,
      // fontWeight: "bold",
      //     color: color_codes.navy,
      paddingBottom: 5,
  },


/*************  SCREEN 2 : header : text box containrs ******************/
  
  dashboard_text_label: {
    // fontFamily: 'monospace',
//     color: "rgb(183, 177, 177)",
    color: "white",
    fontSize: 16,
    fontWeight: "bold",
//     color: color_codes.navy,
    paddingBottom: 5,
  },

  dashboard_text_description: {
      // color: "rgb(183, 177, 177)",
      color: "rgb(234, 231, 225)",
//     color: "white",
    fontSize: 12,      
//     color: "white",
//     fontSize: 16,
//     fontWeight: "bold",
    paddingBottom: 5,
  },

  dashboard_text_value: {
    fontFamily: variables.global_font_specs.family,
    fontSize: 15,
    // fontWeight: "bold",
    color: color_codes.cornflowerblue,
  },
  dashboard_text_unit: {
    fontSize: 15,
    fontWeight: "bold",
    color: color_codes.cornflowerblue,
  },
  dashboard_value_container: {
    // paddingTop:10,
    flexDirection: "row",
    // borderWidth:1,
    // borderColor: "red"
  },

dashboard_value_container_top_row : {
      flex: 1,
            // borderWidth: 1,
      // borderColor:"red",
      marginTop:5,
      paddingLeft:15,

},

dashboard_value_container_bottom_row : {
      flex: 1,
      // borderWidth: 1,
      // borderColor:"red",
      textAligh: "center",
      marginBottom:15,
      paddingLeft:15,
      
},



  app_sub_container: {
//     borderWidth: 12,
//     borderColor: "black",
    // borderRadius:20,
//     marginTop: 10,
    flex: 3,
//     flexGrow: 2,
    // width: 600,
//     width: variables.isDesktop
//       ? app_screen_width
//       // : app_screen_width,
//       : Dimensions.get("window").width,
    // height: Dimensions.get("window").height,
    // borderWidth:12,
    // borderColor: 'yellow',
    // backgroundColor: "yellow",
    backgroundColor: color_codes.lightgrey,
    zIndex: 3, // works on ios
  elevation: 3, // works on android
  },

  app_sub_container_lot_details: {
//     borderWidth: 12,
//     borderColor: "black",
    // borderRadius:20,
//     marginTop: 10,
    flex: 4,
//     flexGrow: 2,
    // width: 600,
    
//     width: variables.isDesktop
//       // ? 0.2 * Dimensions.get("window").width
//     ? app_screen_width
// //     : app_screen_width,
//       : Dimensions.get("window").width,
    // height: Dimensions.get("window").height,
    // borderWidth:12,
    // borderColor: 'yellow',
    // backgroundColor: "yellow",
//     backgroundColor: color_codes.lightgrey,
    backgroundColor: "white",
  },

  // app_sub_container_footer: {
  //   // borderRadius:10,
  //   flex: 2,
  //   // width: 600,
  //   flexDirection: "column",

  //       width:
  //     variables.isDesktop
  //       ?  app_screen_width
  //       : Dimensions.get("window").width,
  //   // height: Dimensions.get("window").height * 0.2,
  //   borderWidth:1,
  //   marginBottom:20,
  //   // borderColor: 'red'
  //   backgroundColor: "white",

  // },

  lot_details_header_container: {
    flex: 1,
    width: variables.isDesktop
      ? 0.6 * Dimensions.get("window").width
      : Dimensions.get("window").width,
//     borderWidth: 1,
//     borderColor: "black",
  },

  lot_details_container: {
    flex: 9,
    width: variables.isDesktop
      ? 0.6 * Dimensions.get("window").width
      : Dimensions.get("window").width,
    // height: Dimensions.get("window").height,
    borderWidth: 1,
    borderColor: "black",
  },

  login_sub_container: {
    // margin: 20,
    // width: 300,
    // display: "flex",
    // flexDirection: "column",
    marginTop: 150,
    // paddingLeft: 40,
    justifyContent: "center",
    alignItems: "center",
    // justifyContent: "center",
    // alignItems: "center",
  },

  login_fields_container: {
    width: 300,
  },

  card_template: {
    elevation: 7,
    flex: 1,
    width:380,
//     width: '100%',
    // height:20,
    flexDirection: "row",
    borderRadius: 5,
//     borderWidth:15,
//     borderColor: "magenta",
//     paddingHorizontal: 15,
    paddingLeft: 15,
    marginBottom: 10,
    // marginTop: 3.5,
    // marginLeft:15,
    // marginRight:20,
    borderBottomWidth: 1,
    borderBottomColor: color_codes.lightgrey,
    // paddingHorizontal: 10,
//     height: variables.isDesktop
//       ? // ? 0.075 * Dimensions.get("window").height
//         0.09 * Dimensions.get("window").height
//       : 0.1 * Dimensions.get("window").height,
    // width: "90%",
    // width: "100%",
    // width:
    //   variables.isDesktop
    //     ? 0.275 * Dimensions.get("window").width
    //     : 0.99 * Dimensions.get("window").width,
      // alignSelf: 'stretch',

//     width: variables.isDesktop
//       ? 0.96 * app_screen_width
//       // : 0.96 * app_screen_width,
//       : Dimensions.get("window").width,

    backgroundColor: "white",
//     backgroundColor: "#f8f8ff",
//     backgroundColor: "green",
//     alignItems: "center",
//     justifyContent: "space-between",
    // marginLeft: 1,
    // marginRight: 1

    shadowColor: "#171717",
    shadowOffset: { width: -2, height: 4 },
    shadowOpacity: 0.2,
    shadowRadius: 3,
  },

  bg_color_grey: {
    backgroundColor: "#f8f8ff",
  },

  tranche_number_box: {
    // backgroundColor: "#dc143c",
    // backgroundColor: "#778899",
    // paddingHorizontal: 12,
    borderRadius: 15,
    justifyContent: "center",
    height: variables.isDesktop ? 60 : 70,
    height: 62,
    alignItems: "center",
    // flex: 1,
    // flexDirection: "column",
  },

  tranche_main_text: {
    fontSize: variables.isDesktop ? 12 : 30,
    // fontSize: 30,
    // color: "#f8f8ff",
    color: "black",
    alignItems: "center",
  },

  non_tranche_main_text: {
    fontSize: variables.isDesktop ? 14 : 14,
    // fontSize: 30,
    width: variables.isDesktop ? 80 : 60,
    // color: "#f8f8ff",
    color: "black",
    alignItems: "center",
    fontWeight: "bold",
  },

  tranche_sub_text: {
    fontSize: 15,
    // color: "#f8f8ff",
    color: "black",
    fontWeight: "bold",
    // alignItems: "center",
  },

  progress_box: {
    // borderWidth: 1,
    // borderColor: "red",
    justifyContent: "center",
    height: 70,
    alignItems: "center",
    marginRight: 5,
    flex:1
  },

  progress_main_text: {
    color: "black",
  },

  progress_sub_text: {
    color: "black",
    fontWeight: "bold",
  },
  generic_box: {
      flex:1,
    justifyContent: "center",
    alignItems: "center",
//     borderColor:"green",
//     borderWidth:10
//     width: variables.isDesktop ? "auto" : 50,
  },

  generic_sub_text: {
    // color: "red",
    fontSize: 14,
    color: "black",
    // fontWeight: "bold",
  },
  generic_sub_text_description: {
    color: color_codes.sienna,
    fontSize: 10,
    // color: "black",
    // fontWeight: "bold",
  },

    milestone_dates: {
    // color: "red",
//     fontSize: 9,
    fontSize: 13,
      // color: "rgb(138, 130, 130)",
      color: color_codes.screen4_values,

//     color: "black",
//     color: color_codes.cornflowerblue,
    // fontWeight: "bold",
  },
  
  stage_name_text: {
//     color: color_codes.sienna,
      color: color_codes.screen4_values,
//     fontSize: 10,
    fontSize: 13,
//     borderColor:"orange",
//     borderWidth:10,
       justifyContent: 'center', 
       textAlign: 'center',

       alignItems: 'center', 
       flex:1
  },

  lot_number_box: {
    // justifyContent: "center",
    alignItems: "center",
    width: variables.isDesktop ? 250 : 50,
    // width: 50,
    // borderWidth: 1,
    // borderColor: color_codes.lightgrey,
    // backgroundColor: color_codes.lightgrey,
  },

  lot_number_main_text: {
    // fontSize: 30,
    color: "black",
    fontWeight: "bold",
  },

// /*************  SCREEN 4 : container for project logo on lots list screen ******************/
  tranche_number_box_lot: {
//     backgroundColor: "#778899",
    backgroundColor: "#d34c4c",
    paddingHorizontal: 0,
    marginRight:5,
    justifyContent: "center",
//     height: 70,
    alignItems: "center",
    borderRadius:5,
//     borderColor:"red",
//     borderWidth: 1,


  },

  tranche_sub_text_lot: {
    fontSize: 12,
    color: "#f8f8ff",
    fontWeight: "bold",
    // alignItems: "center",
  },

  generic_box_lot: {
    justifyContent: "center",
    alignItems: "center",
    width: 40,
  },

  filter_container: {
    // backgroundColor: "green",
    // backgroundColor: "#d3d3d3",
    backgroundColor: "#add8e6",
    // width: "100%",
    // flex: 1,
    // height: 150,
    // width: 20,
    // width: "100%",
    display: "flex",
    flexDirection: "column",
    // justifyContent: "space-between",
    // justifyContent: "center",
    // alignItems: "center",
    // paddingTop: 10,
  },

  filter_sub_container_left: {
    // flex: 3,
    display: "flex",
    // flexDirection: "column",
    justifyContent: "center",
    // paddingLeft: 70,
    // borderWidth: 1,
  },

  filter_sub_container_right: {
    // borderWidth:10,
    // borderColor: "yellow",
    flex: 2,
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    // borderWidth: 1,
  },

  cards_container: {
    // backgroundColor: "#d3d3d3",
    //         borderWidth:10,
    // borderColor: "green",
    backgroundColor: color_codes.lightgrey,
    flex: 12,
    // height: "100%",
    width: "100%",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    // borderWidth:10,
    // borderColor: "orange",
    paddingTop: 20,
    paddingBottom: 20,
  },

  cards_flatlist_container: {
    flex: 1,
  },

  // filter_button_template: {
  //   // borderRadius: 7,
  //   // flex: 1,
  //   // width: 20,
  //   // width: 175,
  //   width: "100%",
  //   height: 40,
  //   // backgroundColor: "#add8e6",
  //   marginHorizontal: 5,
  //   marginVertical: 1,
  //   paddingHorizontal: 5,
  //   justifyContent: "center",
  //   borderBottomWidth: 1,
  //   borderBottomColor: color_codes.lightgrey,
  //   // alignItems: "center",
  //   hover : {
  //     transform: "scale(0.6)",
  //     transitionDuration: "0.5s",
  //     backgroundColor: "red"
  //   }
  // },

  filter_button_text: {
    fontSize: 14,
    // fontWeight: "bold",
  },

  summary_card_title: {
    fontSize: 15,
    // fontWeight: "bold",
  },

  summary_card_sub_title: {
    fontSize: 20,
    fontWeight: "bold",
    color: "#800000",
  },

  summary_card_template: {
    // flex: 1,
    flexDirection: "row",
    borderRadius: 9,
    // marginHorizontal: 20,
    // marginBottom: 10,
    borderBottomWidth: 1,
    borderBottomColor: color_codes.lightgrey,
    paddingHorizontal: 10,
    height: variables.isDesktop
      ? 0.08 * Dimensions.get("window").height
      : 0.06 * Dimensions.get("window").height,
    // width: "90%",
    width: variables.isDesktop
      ? 0.275 * Dimensions.get("window").width
      : 0.9 * Dimensions.get("window").width,
    backgroundColor: "#f8f8ff",
    // backgroundColor: "#add8e6",
    alignItems: "center",
    justifyContent: "space-between",
  },

  lots_count_banner: {
    // backgroundColor: "black",
    width: "100%",
    // justifyContent: "center",
    alignItems: "center",
    padding: 5,
    // marginTop: 70,
    marginBottom: 2,
  },

  lots_count_text: {
    fontWeight: "bold",
    fontSize: 14,
    color: "white",
  },

  progress_box_lot: {
    // borderWidth: 1,
    // borderColor: "red",
    // backgroundColor: "#008080",
    justifyContent: "center",
    height: 60,
//     height: 70,
    alignItems: "center",
    // borderWidth: 3,
    // borderColor: "#2e8b57",
    borderWidth: 1,
    // borderBottomWidth: 1,
    borderColor: "#2e8b57",
    padding: 5,
    // marginRight:5
  },

  custom_button_wrapper: {
    borderRadius: 20,
    marginBottom: 20,
    marginLeft: 10,
    width: "50%",
  },

  loading_state_container: {
    flex: 1,
      height:(device_height/2) + 280,
    justifyContent: "center",
    alignItems: "center",
      //   borderWidth: 10,
//     borderColor: "pink",
  },

  cards_plus_filter_container: {
    // borderWidth: 10,
    // borderColor: "pink",
    flex: 1,
  },

  error_message_box: {
    // flex: 3,
    marginTop: 20,
    justifyContent: "center",
    alignItems: "center",
  },

  error_message_text: {
    color: "red",
  },

  button: {
    backgroundColor: "#ff5c5c",
  },

  login_page_input_text_box: {
    height: 40,
    margin: 12,
    borderWidth: 1,
    padding: 10,
  },

  /************* NOTE IN USE - CHECK BEFORE DELETING ******************/
  header_button_container: {

    width:155, justifyContent: "center" , 
    marginTop: 70, 
    height: 37, 
    paddingHorizontal: 10, 
    marginsBottom: 2, 
    backgroundColor: "#c83535", 
    borderRadius:4,  
    shadowColor: "#171717",
    shadowOffset: 
      { width: -2, height: 4 },
      shadowOpacity: 0.2,
      shadowRadius: 6,
      elevatoin: 10,            
  },

  /************* SCREEN 2 : Buttons for Prev/Next & Show Lots  ******************/

      header_button: {
            flex: 1,
            //     backgroundColor: "#ff5c5c",
            // backgroundColor: "rgb(255, 255, 255)",
            //     paddingLeftLeft: 5,
            marginRight: 19,
            marginTop: 13,
            //     marginBottom: 5,
            //     marginTop: 5,
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            //     borderWidth: 1,
            //     borderColor: color_codes.lightgrey,
            borderRadius:3,
            elevation:10,
            height: 30,
      },

      header_button_text: {
            fontSize: 9,            
            fontFamily: variables.global_font_specs.family,
            color: "rgb(67, 47, 47)",
                // fontWeight: "bold"
      },

/*************  Screen 2 Filters not using Toggle switches******************/
  toggle_button : {
    flex: 1,
          // width: 30,
//     backgroundColor: "#ff5c5c",
    marginRight: 5,
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row",
//     borderWidth: 1,
//     borderColor: color_codes.lightgrey,
    borderRadius:3,
    elevation:10,
    height: 30,
},

/*************  SCREEN 2 : Filters text (non-toggle)******************/ 
toggle_button_text: {
//     fontSize: 12,
    fontSize: 13,
//     fontWeight: "bold",
//     color: "black"
    color: "rgb(184, 169, 169)"
  },


/*************  SCREEN 3 : cards for displaying list of Lots  ******************/
    lot_card_template: {
            elevation: 7,
            flexDirection: "row",
            borderRadius: 5,
            // paddingHorizontal: 15,
            // paddingBottom:15,
            // paddingTop:15,
            marginBottom:15,
            marginLeft:10,
            marginRight:10,
            // marginTop:5,
            // paddingRight:10,
            borderBottomWidth: 1,
            // borderBottomColor: color_codes.lightgrey,
            borderBottomColor: "rgb(243, 241, 241)",
            // height: variables.isDesktop
            //       ? // ? 0.075 * Dimensions.get("window").height
            //       // 0.28 * Dimensions.get("window").height
            //       0.16 * Dimensions.get("window").height
            //       // 0.09 * Dimensions.get("window").height
            //       : 0.1 * Dimensions.get("window").height,
            // width: variables.isDesktop
            //       ? 1 * app_screen_width
            //       // : 1 * app_screen_width,
            //       : Dimensions.get("window").width,
            backgroundColor: "white",
            alignItems: "center",
            justifyContent: "space-between",
            shadowColor: "#171717",
            shadowOffset: { width: -2, height: 4 },
            shadowOpacity: 0.2,
            shadowRadius: 3,
            // borderWidth:1,
            // borderColor:"green",
            // paddingTop:35,
            // paddingBottom:25,
      },

      
      lot_card_template_text_container: {
            flex:3,
            flexDirection: "column",
            // borderColor:"orange",
            // borderWidth:1,

      },

/*************  SCREEN 4 :  container box to hold section details  ******************/
      lot_detail_template_text_container: {
            // flex:1,
            flexDirection: "column",
            // width: 30,
            //     marginRight:20,
//     paddingRight:10,

            // borderColor:"orange",
            // borderWidth:10
      },

/*************  SCREEN 4 :  container box to hold timeline  ******************/
      timeline_container: {
      // flex:1,
      flexDirection: "column",
      backgroundColor: "#e3d9d9",
      borderRadius:10,
      // width: 30,
          marginLeft:30,
          marginRight:30,
//     paddingRight:10,

      // borderColor:"orange",
      // borderWidth:10
},

/*************  SCREEN 3 :  row container  ******************/
screen3_row_container: {
      flex:1,
      flexDirection: "row",
      marginBottom:5,
      paddingLeft:20,
      // paddingRight:20,
      // borderBottomColor:color_codes.lightgrey,
      // borderBottomWidth:2
      // justifyContent: 'space-between'
      // borderColor:"yellow",
      // borderWidth:1
},

/*************  SCREEN 4 :  row container  ******************/
      screen4_row_container: {
            flex:1,
            flexDirection: "row",
            marginBottom:5,
            paddingLeft:20,
            // paddingRight:20,
            // borderBottomColor:color_codes.lightgrey,
            // borderBottomWidth:2
            // justifyContent: 'space-between'
            // borderColor:"yellow",
            // borderWidth:1
      },

      lot_card_template_text_container_row_box_left: {
            flex:1,
      },

      lot_card_template_text_container_row_box_right: {
            flex:2,
      },

      lot_card_template_text_container_row_box: {
            flex:1,
      },

      ImageIconStyle: {
      // flex:1,
      height: 62,
      width: 64,
      resizeMode: 'center',
      borderRadius:5
      },

/*************  SCREEN 3 : Lot name each card  ******************/
      lot_name: {
//     fontFamily: 'Open Sans'
    fontFamily: 'Calibri',
    fontSize: 16,
    // color: "black",
    color: "rgb(141, 147, 198)",
    marginRight: 20,
//   color: "rgb(138, 130, 130)",

    fontWeight: "bold",
    // alignItems: "center",
  },

  
/*************  SCREEN 4 : Lot Detail values   ******************/
      lot_card_template_text_labels_large: {
//     fontFamily: 'Open Sans',
    fontSize: 13,
//     color: "black",
    marginRight: 20,
  color: "rgb(138, 130, 130)",
//     fontWeight: "bold",
    // alignItems: "center",
  },

/*************  SCREEN 4 : containers inside timeline charts   ******************/

  milestone_container: {
      // flex:1,
      // flexDirection:"row"
    justifyContent: "center",
    alignItems: "center",
//     borderColor:"green",
//     borderWidth:10
//     width: variables.isDesktop ? "auto" : 50,
  },

    lot_card_template_text_labels: {
//     fontFamily: 'Open Sans',
    fontSize: 13,
//     color: "black",
  color: "rgb(138, 130, 130)",

//     fontWeight: "bold",
    // alignItems: "center",
  },

    lot_card_template_text_values: {
//     fontFamily: 'Open Sans',
      fontSize: 12,
//     color: "black",
  color: "rgb(138, 130, 130)",
    fontWeight: "normal",
    // alignItems: "center",
  },

      app_sub_container_image_header: {
      //     borderWidth: 12,
      //     borderColor: "orange",
      flex: 2,
      //     flexGrow: 1,
      flexDirection: "column",
      //     marginTop: 20,
      //     borderTopLeftRadius :80,
      //     borderTopRightRadius :80,
      // backgroundColor: "white",
      //     backgroundColor: color_codes.lightgrey,
      //     backgroundColor: "pink",
      // backgroundColor:  "#deb887",
      // width: 600,
      //     width: variables.isDesktop
      //     ? app_screen_width
      // //     : app_screen_width,
      //       : Dimensions.get("window").width,

      //     ? 0.2 * Dimensions.get("window").width
      // height: Dimensions.get("window").height * 0.2,
      // borderWidth:1,
      // borderColor:color_codes.lightgrey
      overflow:"hidden",
            //   borderRadius:80,
      backgroundColor: "white",
      paddingBottom:0,

      },

      ImageOnHeaderStyle: {
      //     flex:1,
      height: 200,
      width: 385,
      resizeMode: 'stretch',
      borderRadius:5
      },

      /*************  section titles on Lot Details screen  ******************/
      lot_detail_page_section_header: {
            // flex:1,
            flexDirection: "column",
            // borderColor:"orange",
            // borderWidth:1,
            height: 30,
            justifyContent:"center",      
            textAlign:"center",
            // backgroundColor:"#ffff00",
            // backgroundColor:"rgb(196, 196, 94)",  //yellow + crimson tinge
            backgroundColor:"rgb(245, 195, 195)", // pinkish tinge
            
            borderRadius:15,
            marginTop:20,
            marginBottom:20,
            marginRight:15,
            marginLeft:15,
            elevation:20,
            fontSize:12,
            fontWeight:"bold",
            fontFamily: font_family,
                        shadowColor: "#171717",
                  shadowOffset: { width: -2, height: 4 },
                  shadowOpacity: 0.2,
                  shadowRadius: 3,
      },

      /*************  SCREEN 4 :  styling for timeline cards  ******************/
      lot_details_card_template: {
      //     backgroundColor:"rgb(234, 234, 234)",
      //     backgroundColor:"green",
      elevation: 7,
      flex: 1,
      // height:20,
      flexDirection: "column",
      borderRadius: 15,
      //     borderWidth:15,
      //     borderColor: "magenta",
      //     paddingHorizontal: 10,
      //     marginLeft: 10,
      //     marginRight: 10,
      //     paddingRight: 10,
      //     paddingRight: 25,
      //     marginBottom: 10,
      // marginTop: 3.5,
      //     marginRight:10,
      borderTopWidth: 1,
      borderBottomWidth: 1,
      borderTopColor: color_codes.lightgrey,
      borderBottomColor: color_codes.lightgrey,
      // paddingHorizontal: 10,
      //     height: variables.isDesktop
      //       ? // ? 0.075 * Dimensions.get("window").height
      //         0.2 * Dimensions.get("window").height
      //       : 0.1 * Dimensions.get("window").height,
      // width: "90%",
      // width: "100%",
      // width:
      //   variables.isDesktop
      //     ? 0.275 * Dimensions.get("window").width
      //     : 0.99 * Dimensions.get("window").width,

      //     width: 0.2 * Dimensions.get("window").width,

      //     backgroundColor: "white",
      // backgroundColor: "#f8f8ff",
      alignItems: "center",
      justifyContent: "center",
      // marginLeft: 1,
      // marginRight: 1

      shadowColor: "#171717",
      shadowOffset: { width: -2, height: 4 },
      shadowOpacity: 0.2,
      shadowRadius: 3,
      }, 

      custom_left_padding : {
            paddingLeft:10
      },

      /*************  SCREEN 1: circles inside  cards  ******************/
      screen_circle_icon: {
                  borderRadius: circle_radius.large,
                  width: circle_radius.large,
                  height: circle_radius.large,
                  backgroundColor:'#f00',
                  justifyContent: 'center',
                  alignItems: 'center'
      },

      /*************  SCREEN 4: circles to indicate milestones  ******************/
      circle_ind_lots_screen: {
                  borderRadius: circle_radius.small,
                  width: circle_radius.small,
                  height: circle_radius.small,
                  backgroundColor:'#f00',
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginRight:10,
                  marginTop:5,
                  marginBottom:5,
      },

      text_with_underline : {
            textDecorationLine :  "underline",
            textDecorationThickness: "3px",
            textUnderlineOffset : "0.5rem",
      },

      /* chart-kit titles*/

      chart_kit_title_container: {
            borderWidth:variables.showBordersFlag ? 1 : 0, 
            borderColor: "blue", 
            // borderRadius:20,
            backgroundColor: "rgb(255, 229, 229)",
            // backgroundColor: "rgb(82, 72, 107)",
            flex: 1, 
            justifyContent:"center", 
            alignItems: "center",
            marginTop:10,
            marginBottom:10,
            flexDirection:"row",
            // textAlign: "center",
            // marginBottom:10,
            // textAlignVertical: "center"
            // height:30,

      },
      chart_kit_title_text: {
            // flex:1,
            fontFamily: "Helvetica",
            height:15,
            fontSize:12,
            fontWeight:"bold",
            fontFamily: "Arial",
            borderWidth: variables.showBordersFlag ? 1 : 0,
            justifyContent:"center", 
            alignItems: "center",
            textAlign: "center",
            textAlignVertical: 'center',
            alignContent:"center",
            // marginTop:10,
            // color:"rgb(132, 128, 128)",
            color:"rgb(28, 174, 181)",
            // marginBottom:30,
      },

      horizontal_line :  {
            marginTop:15,
            borderBottomColor: 'rgb(198, 119, 119)',
            borderBottomWidth: 5,
      },

      elevate_container: {
            shadowColor: "#171717",
            shadowOffset: { width: -2, height: 4 },
            shadowOpacity: 0.2,
            shadowRadius: 3,
      },

      grid_container : {
            flex:1,
            flexDirection: "column",
            borderWidth: variables.showBordersFlag ? 5 : 0,
            borderColor:"yellow",
            maxHeight: 700,
      },
      grid_container_row : {
            flex:1,
            flexDirection: "row",
            borderWidth: variables.showBordersFlag ? 5 : 0,
            borderColor:"orange"
      },
      grid_box_container: {
            flex:1,
            flexDirection: "column",
            borderWidth: 1,
            borderColor:"lightgrey",
            borderRadius:2,
            margin:5,
            paddingHorizontal:10,
            alignItems: "center",
            justifyContent: "center",
            alignContent: "center",
            shadowColor: "#171717",
            shadowOffset: { width: -2, height: 4 },
            shadowOpacity: 0.2,
            shadowRadius: 6,
            elevatoin: 10,   
            // height: 80,
            // maxHeight: 80,
            // minHeight: 80,   // v 2.0.3 changes
            maxWidth: 160,
            // maxHeight: 65,
            // paddingTop:15
      },
      grid_box_container_row: {
            flex:1,
            borderWidth: variables.showBordersFlag ? 1 : 0,
            borderColor:"sienna",
            alignItems: "center",
            justifyContent: "center",
            alignContent: "center"
      },
      grid_box_text_label: {
            fontFamily: variables.global_font_specs.family,
            fontSize:10,
            color: "rgb(147, 137, 137)",
            // color: "white",
            alignItems: "center",
            justifyContent: "center",
            alignContent: "center",
            textAlign: "center",

      },
      grid_box_counter_text: {
            fontFamily: variables.global_font_specs.family,
            fontSize:18,
            color: "rgb(147, 137, 137)",
            // color: "white",
            // fontWeight: "bold",
            alignItems: "center",
            justifyContent: "center",
            alignContent: "center",
            textAlign: "center"

      },
panel1_summary_container: {
      paddingVertical: 10,
      marginVertical: 5,
	 borderWidth: variables.showBordersFlag ?  10 : 0, 
	// flex:1, 
      height: 80,
	flexDirection: "row",
      borderRadius: 5,
      // backgroundColor:"white"
      backgroundColor:"rgb(248, 252, 253)"
      
},

panel1_summary_container_box:  {
	flex: 1, 
	borderWidth:  1, 
	borderColor: "lightgrey",
	flexDirection: "column",
      marginHorizontal:5,
      // borderRadius: 10,
      borderRadius: 3,
      height: "100%",
      // backgroundColor: "rgb(49, 39, 77)",
      // backgroundColor: "#0087b0",
      backgroundColor: "rgb(237, 237, 235)",
      shadowColor: "#171717",
      shadowOffset: { width: -2, height: 4 },
      shadowOpacity: 0.2,
      shadowRadius: 6,
},
panel1_summary_container_box_row:  {
	flex: 1, 
      borderWidth: variables.showBordersFlag ? 5 : 0, 
	borderColor: "green", 
      paddingLeft:20,
},
panel1_summary_container_box_counter:  {
	fontSize: 17, 
	// fontWeight: "bold",
      color: "rgb(89, 93, 131)"

},
panel1_summary_container_box_text:  {
	fontSize: 14, 
	// fontWeight: "bold",
      color: "rgb(89, 93, 131)"
}      ,

filter_panel: {
  margin:4,
  borderRadius:5,
  backgroundColor:"rgb(3, 15, 25)"
}

});





export { font_family, style_templates };




